import { useUser } from '@adsk/alloy-provider';
import { LinkButton } from '@adsk/alloy-react-button';
import { translate } from '../../../../../helpers';

import DropDown, { DropDownPropTypes } from '../components/DropDown';
import FilterSearchIcon from '../components/FilterSearchIcon';

const AssignToDropDown = ({ onChange, ...restProps }) => {
  const { user: currentUser } = useUser();

  const onSelectMyActionItems = () => {
    const userWithValue = {
      ...currentUser,
      value: currentUser?.autodeskId,
    };
    onChange([userWithValue]);
  };

  return (
    <div style={{ position: 'relative' }}>
      <DropDown
        {...restProps}
        label={translate('rpPlugin.new.assignedTo')}
        labelKey="name"
        valueKey="autodeskId"
        placeholder={translate('rpPlugin.filter.assignedToUser')}
        searchable
        searchIcon={<FilterSearchIcon />}
        searchPlaceholder={translate('rpPlugin.filter.assignedToSearch')}
        onChange={onChange}
      />
      <LinkButton
        style={{ position: 'absolute', right: 15, top: 0 }}
        onClick={onSelectMyActionItems}
      >
        {translate('rpPlugin.filter.myActionItems')}
      </LinkButton>
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const { label, placeholder, ...AssignToDropDownPropTypes } = DropDownPropTypes;

AssignToDropDown.propTypes = AssignToDropDownPropTypes;

export default AssignToDropDown;
